import React from 'react'
// @ts-ignore no types
import _ from 'lodash'
// @ts-ignore no types
import { Text, Breadcrumb, constants, PageLayout } from '@adc/ui-adc'
import type { Maybe } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import { Address } from 'common/components/address'
import SectionPanel from '../../components/sectionPanel'
// @ts-ignore no types
import { CombinedListingType, useListingContext } from '../../context/listing'
// @ts-ignore no types
import cls from './index.scss'

const cx = classnames.bind(cls)

type State = Record<string, string>

const stateList = constants.optionLists.states
const states = {} as State

stateList.forEach((state: State) => {
  states[state.value] = state.text
})

const optionalSuffix = (
  string: string,
  suffixTest: string,
  suffixAppend: string
) =>
  string.toLowerCase().endsWith(suffixTest) ? string : string + suffixAppend

const smartKebabCase = (input?: Maybe<string>): string => {
  if (!input) return ''
  const words = input.trim().split(/\s+/)

  // If it's a single word, just lowercase it
  if (words.length === 1) {
    return words[0].toLowerCase()
  }

  // If it's multiple words, kebab-case each word except compound ones
  return words
    .map(word => {
      // Preserve compound words like McLennan or DeSoto
      if (/^[A-Z][a-z]+(?:[A-Z][a-z]+)+$/.test(word)) {
        return word.toLowerCase()
      }
      return _.kebabCase(word)
    })
    .join('-')
}
interface BreadCrumb {
  label?: Maybe<string>
  url: string
}

export const buildBreadCrumbs = (
  listing: CombinedListingType,
  isCancelled?: boolean
): BreadCrumb[] => {
  const address = listing.primary_property.summary?.address
  if (!address || _.isEmpty(address)) {
    return []
  }

  const {
    country_primary_subdivision,
    country_secondary_subdivision,
    municipality,
    postal_code,
  } = address
  const street_address = Address.toLines(listing)[0] || ''

  const primarySubdivision = (
    country_primary_subdivision || ''
  ).toLocaleLowerCase()

  const out = [
    { label: 'Auction.com', url: '/' },
    {
      label: country_primary_subdivision
        ? states[country_primary_subdivision]
        : '',
      url: `/residential/${primarySubdivision}`,
    },
    {
      label: optionalSuffix(
        country_secondary_subdivision || '',
        'county',
        ' County'
      ),
      url: optionalSuffix(
        `/residential/${primarySubdivision}/${smartKebabCase(
          country_secondary_subdivision
        )}`,
        'county',
        '-county'
      ),
    },
    {
      label: municipality,
      // @ts-ignore TODO:
      url: `/residential/${primarySubdivision}/${smartKebabCase(
        municipality
      )}_ct`,
    },
    {
      label: postal_code,
      // @ts-ignore TODO:
      url: `/residential/${postal_code}_zp`,
    },
    {
      label: street_address.trim(),
      url: ``,
    },
  ]
  if (!isCancelled) {
    out.concat([
      {
        label: listing.primary_property.summary?.street_address || '',
        url: listing.listing_page_path,
      },
    ])
  }
  return out
}

interface Link {
  label?: Maybe<string>
  url?: string
}

const breadCrumbLink = ({ label, url }: Link) => ({
  key: label,
  content: <a href={url}>{label}</a>,
})

const activeBreadCrumb = ({ label = '' }: Link) => ({
  key: label,
  content: (
    <Text color='gray' size='tiny'>
      {label}
    </Text>
  ),
  active: true,
})

interface SemanticBreadCrumbsType {
  key?: Maybe<string>
  content: any
}

const BreadCrumbsContent = ({
  semanticBreadCrumbs,
}: {
  semanticBreadCrumbs: SemanticBreadCrumbsType[]
}) => (
  <div
    className={cx('breadcrumbs', 'u-pt-2', 'u-pb-2')}
    data-elm-id='breadcrumbs'
    id='breadcrumbs'
  >
    <Breadcrumb icon='right angle' sections={semanticBreadCrumbs} />
  </div>
)

interface BreadCrumbsProps {
  isCancelled?: boolean
  isRedesign?: boolean
}

const BreadCrumbs = ({ isCancelled, isRedesign = false }: BreadCrumbsProps) => {
  const { listing } = useListingContext()
  const breadCrumbList = buildBreadCrumbs(listing, isCancelled)
  const semanticBreadCrumbs = breadCrumbList.map((link, i) =>
    i === breadCrumbList.length - 1
      ? activeBreadCrumb(link || {})
      : breadCrumbLink(link || {})
  )

  return isRedesign ? (
    <div className={cx('highlighted', 'u-mb-3')}>
      <PageLayout width='large' horizontalPadding>
        <BreadCrumbsContent semanticBreadCrumbs={semanticBreadCrumbs} />
      </PageLayout>
    </div>
  ) : (
    <SectionPanel elmId='breadcrumbs' highlighted compact>
      <BreadCrumbsContent semanticBreadCrumbs={semanticBreadCrumbs} />
    </SectionPanel>
  )
}

export default BreadCrumbs
